import React, { useState } from "react";
import { toast } from "react-toastify";
import { USER_DELETION_REASONS } from "../../../constants";
import { JdsButton } from "../../../components/jds/JdsButton";

export default function FormDeleteUser({ onSubmitForm, onCancel }) {

  const [selectedReason, setSelectedReason] = useState("");
  const [otherReason, setOtherReason] = useState("");

  const handleReasonChange = event => {
    setSelectedReason(event.target.value);
    if (event.target.value !== "Outro:") {
      setOtherReason("");
    }
  };

  const handleOtherReasonChange = event => {
    setOtherReason(event.target.value);
  };

  const handleCancel = () => {
    onCancel();
  };

  const handleSubmit = event => {
    event.preventDefault();

    let finalReason = selectedReason;
    if (selectedReason === "Outro:") {
      finalReason = otherReason;
    }

    if (!finalReason) {
      toast.warn("Por favor, selecione ou informe um motivo de exclusão.");
      return;
    }

    onSubmitForm(finalReason);
  };

  return (
    <form onSubmit={handleSubmit}>
      <label className="form-label">Informe o motivo da exclusão:</label>
      {Object.entries(USER_DELETION_REASONS).map(([key, text]) => (
        <div className="ml-5" key={key}>
          <label className="cd-check">
            <input
              type="radio"
              name="reason"
              className="cursor-pointer"
              value={text}
              checked={selectedReason === text}
              onChange={handleReasonChange}
            />
            {text}
          </label>
        </div>
      ))}

      {selectedReason === USER_DELETION_REASONS.OTHER  && (
        <div>
          <label htmlFor="otherReasonInput">Detalhe a razão:</label>
          <input
            type="text"
            id="otherReasonInput"
            className="form-control"
            value={otherReason}
            onChange={handleOtherReasonChange}
            placeholder="Digite o motivo aqui..."
            maxLength={255}
            minLength={15}
            required
          />
        </div>
      )}
      <div className="cd-actions cd-actions--end mt-4">
        <JdsButton variant="outlined" color="neutral" onClick={handleCancel}>
          Cancelar
        </JdsButton>
        <JdsButton type="submit" color="error">
          Deletar usuário
        </JdsButton>
      </div>
    </form>
  );
}
